// -*-mode: rjsx -*-
// REACT
import React, { useState, useEffect } from "react"
// eslint-disable-next-line
import clsx from "clsx"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { withStyles, createStyles, makeStyles } from "@material-ui/core/styles"
// eslint-disable-next-line
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"

// COLORS
// eslint-disable-next-line
import lime from "@material-ui/core/colors/lime"
// eslint-disable-next-line
import grey from "@material-ui/core/colors/grey"
// eslint-disable-next-line
import red from "@material-ui/core/colors/red"

// FLASH
// eslint-disable-next-line
import { globalStyles, useGlobalStyles } from "../FlashStyles.js"

// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<FlashBottomPad>")

const useDefaultStyles = makeStyles(theme => ({
    rootDiv: {
//        position: "fixed",
//        bottom: 0,
//        width: "100%",
        zIndex: 1000,
        height: 72,

        //
        // mobile
        //
        marginTop: 10,
        marginBottom: 70 ,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: 30,
            marginBottom: 30,
        },

        
        // below is the actual texcture - it does work
        //        backgroundColor: grey[200], 
        //        borderTop: "1px solid",
        //        borderTopColor: grey[300],
        //	borderRadius: 0,
    },

    buttonsDiv: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        width: "100%",
        height: 72,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
	    maxWidth: 600,
        },

    },


    nextButtonDiv: {
        width: "30%",
        height: "55%",
    },

    nextButtonLongDiv: {
        width: "55%",
        height: "55%",
    },

    backButtonDiv: {
        width: "30%",
        height: "55%",
    },


    nextButton: {
        width: "100%",
        height: "100%",
        
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.custom.nextButton,
        "&:hover": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.custom.nextButtonLight,
        },
        
    },

    backButton: {
        width: "100%",
        height: "100%",
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },
    
}), { name: "FlashBottomPad" })

// keep adding this stuff

let FlashBottomPad = (props) => {

    // eslint-disable-next-line
    const { children, backButton, nextButton
          } = props

    const classes = {
        ...useDefaultStyles(),
    }

    const [redirectState, setRedirect] = useState({
        toRedirect: false,
        toLink: null
    })
    
    const handleBackClick = () => {
        if(backButton.onClick) {
            if(backButton.onClick(backButton.onError)) {
                log.debug("handleBackClick(): going to link = ", backButton.link)
                setRedirect({...redirectState, toRedirect: true, toLink: backButton.link})
            }
        } else {
            log.debug("handleBackClick(): going to link = ", backButton.link)
            setRedirect({...redirectState, toRedirect: true, toLink: backButton.link})
        }
    }

    const handleNextClick = () => {
        if(nextButton.onClick) {
            if(nextButton.onClick(nextButton.onError)) {
                log.debug("handleNextClick(): going to link = ", nextButton.link)
                setRedirect({...redirectState, toRedirect: true, toLink: nextButton.link})
            }
        } else {
            log.debug("handleNextClick(): going to link = ", nextButton.link)
            setRedirect({...redirectState, toRedirect: true, toLink: nextButton.link})
        }
    }
    
    useEffect(() => {
    })

    if(redirectState.toRedirect) {
        redirectState.toRedirect = false
        return (<Redirect push to={redirectState.toLink}/>)
    }

    return (
        <div className={classes.rootDiv}>
          <div style={{display: "flex", alignItems:"center", justifyContent: "center"}}>
            <div className={classes.buttonsDiv}>
              { backButton &&
                <div className={classes.backButtonDiv}>
                  <Button className={classes.backButton} onClick={handleBackClick}>{backButton.text}</Button>
                </div>
              }

              { nextButton &&
                <div className={clsx(classes.nextButtonDiv, {
                    [classes.nextButtonLongDiv]: nextButton.text.length > 10
                })}>
                  <Button className={classes.nextButton} onClick={handleNextClick}>{nextButton.text}</Button>
                </div>
              }
            </div>
          </div>
          
        </div>
    )
}

export default FlashBottomPad

